import { createSlice } from '@reduxjs/toolkit';

const MAX_REQUESTS = 5000;

const networkMonitorSlice = createSlice({
  name: 'networkMonitor',
  initialState: {
    requests: [],
    filters: [],
    selectedRequests: [],
    capturing: false,
    connected: false,
    filterStats: { total: 0, blocked: 0, allowed: 0 },
  },
  reducers: {
    setConnected(state, action) {
      state.connected = action.payload;
    },
    setCapturing(state, action) {
      state.capturing = action.payload;
    },
    addRequest(state, action) {
      state.requests.push(action.payload);
      if (state.requests.length > MAX_REQUESTS) {
        state.requests = state.requests.slice(-MAX_REQUESTS);
      }
      state.filterStats.total = state.requests.length;
      if (action.payload.blocked) {
        state.filterStats.blocked += 1;
      } else {
        state.filterStats.allowed += 1;
      }
    },
    clearRequests(state) {
      state.requests = [];
      state.filterStats = { total: 0, blocked: 0, allowed: 0 };
      state.selectedRequests = [];
    },
    setSelectedRequests(state, action) {
      state.selectedRequests = action.payload;
    },
    addFilter(state, action) {
      state.filters.push(action.payload);
    },
    updateFilter(state, action) {
      const { index, filter } = action.payload;
      if (index >= 0 && index < state.filters.length) {
        state.filters[index] = filter;
      }
    },
    removeFilter(state, action) {
      state.filters.splice(action.payload, 1);
    },
    setFilters(state, action) {
      state.filters = action.payload;
    },
    updateFilterStats(state) {
      const blocked = state.requests.filter((r) => r.blocked).length;
      state.filterStats = {
        total: state.requests.length,
        blocked,
        allowed: state.requests.length - blocked,
      };
    },
  },
});

export const {
  setConnected,
  setCapturing,
  addRequest,
  clearRequests,
  setSelectedRequests,
  addFilter,
  updateFilter,
  removeFilter,
  setFilters,
  updateFilterStats,
} = networkMonitorSlice.actions;

export default networkMonitorSlice.reducer;
